import { LoaderProgress } from "components/icon/loaderProgress.component";
import { useEffect, useMemo } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useAuthStore } from "stores/authStore/authStore";
import { isSettingEnabled } from "model/settings.logic";
import { ApplicationList } from "web-apps/company/components/applications/applicationList.component";
import { useApplicationStore } from "web-apps/company/stores/applicationStore/applicationStore";
import { useCompanyStore } from "web-apps/company/stores/companyStore/companyStore";

export const ApplicationPage = () => {
  const [authState] = useAuthStore();
  const [companyState] = useCompanyStore();
  const [applicationState] = useApplicationStore();
  const history = useHistory();
  const location = useLocation();

  const havePublicModule = useMemo(() => {
    return isSettingEnabled(
      companyState.companySettings,
      "CompanyShowPublicGigModule",
    );
  }, [companyState.companySettings]);

  useEffect(() => {
    if (havePublicModule) return;

    const params = new URLSearchParams(location.search);
    params.set("page", "Subscription");

    history.replace({
      pathname: location.pathname,
      search: params.toString(),
    });
  }, [havePublicModule, history, location.pathname, location.search]);

  return authState.isLoading ||
    companyState.isLoading ||
    applicationState.isLoading ? (
    <LoaderProgress />
  ) : (
    <ApplicationList />
  );
};
